import mileageListingAutoGenerateParamsFactory from "../../../../modules/mileage/listing/common/mileage-listing-auto-generate-request.factory";
import {
  DelegationAddFromAllMileagesErrorType,
  DelegationAddFromAllMileagesNoMileagesAvailableError,
} from "./delegation-add-from-all-mileages-error";

const createNoMileagesAvailableError =
  (): DelegationAddFromAllMileagesNoMileagesAvailableError => {
    return {
      message: mileageListingAutoGenerateParamsFactory.createErrorMessage(),
      params: {},
      type: DelegationAddFromAllMileagesErrorType.NO_MILEAGES_AVAILABLE,
    };
  };

const delegationAddFromAllMileagesErrorFactory = {
  createNoMileagesAvailableError,
};

export default delegationAddFromAllMileagesErrorFactory;
